<template>
  <div class="cd_issue-card">
    <div class="cd_issue-card--image"><img :src="imageURL" :alt="alt" /></div>
    <div class="cd_issue-card--content">
      <h3 class="cd_issue-card--type">{{issue.type}}</h3>
      <div class="cd_issue-card--description" :inner-html.prop="description | truncate(150, '...')"></div>
    </div>
    <div class="cd_issue-card--actions">
      <div class="cd_issue-card--date">{{issue.date}}</div>
      <router-link :to="{ name: 'issue', params: {id: issue.id} }" class="btn btn-sm btn-success">
        More
      </router-link>
    </div>
  </div>
</template>

<script>

  const bucket = process.env.VUE_APP_BUCKET
  const domain = 'https://images.creekdog.org/'

  export default {
    name: 'IssueCard',
    props: {
      issue: Object
    },
    data () {
      return {
        imageURL: ''
      }
    },
    async created(){
      this.getImage()
    },
    computed: {
      description() {
        return this.$sanitize(this.issue.description)
      },
      alt() {
        if (this.issue.image){
          return this.description
        } else {
          return "No Image Found"
        }
      }
    },
    methods: {
      async getImage() {
        if (this.issue.image){
          let imageConfig = {
            "bucket": bucket,
            "key": "public/"+this.issue.image,
            "edits": {
              "resize": {
                "height": 250,
                "width": 350,
                "fit": "cover"
              }
            }
          }
          this.imageURL = domain + btoa(JSON.stringify(imageConfig))
        } else {
          this.imageURL = "https://assets.creekdog.org/creekdog-icon.svg"
          // this.sanitizedDescription = "No Image available"
        }
      }
    }
  }
</script>
